import { MenuItem } from '@mui/material'
import { InvoiceReadModel, InvoiceState, MarkInvoiceAsPaidCommand } from '../../GeneratedClients/FreeBillApi';
import { useNotify, useRecordContext, useRefresh, useTranslate } from 'react-admin';
import { apiService } from '../../apiService';
import { useMutation } from "react-query";
import firstLetterToLowerCase from '../../helpers/firstLetterToLowerCase';

interface IProps {
  handleClose: () => void
}

const InvoicePaidMenuItem= ({handleClose}: IProps) => {
  
  const invoice = useRecordContext<InvoiceReadModel>()
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const { mutate, isLoading } = useMutation((command: MarkInvoiceAsPaidCommand) => 
    apiService.InvoicesApi.markInvoiceAsPaid({markInvoiceAsPaidCommand: command, id: command.id!}),
    {
      onSuccess: () => {
        notify(translate("resources.invoices.notifications.invoiceStateChanged"))
        refresh()
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )
  const markInvoiceAsPaid = () => { 
    if(invoice.invoiceState === InvoiceState.Canceled) {
      notify(translate("resources.invoices.dialogs.invalidStateChange", {actualState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.Canceled)}`), newState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.Paid)}`)}), {type: "error"}) 
      return
    }
    if(invoice.invoiceState === InvoiceState.Paid) {
      notify(translate("resources.invoices.dialogs.alreadyThatState", {actualState: translate(`resources.invoices.${firstLetterToLowerCase(InvoiceState.Paid)}`)}), {type: "error"}) 
      return
    }
    const command: MarkInvoiceAsPaidCommand = {
      id: invoice.id,
      userId: invoice.userId,
    }
    mutate(command)
    handleClose()
  }

  return (
    <MenuItem 
      disabled={isLoading} 
      onClick={markInvoiceAsPaid} 
      key={"markInvoiceAsPaid"}
    >
      {translate(`resources.invoices.paid`)}
    </MenuItem>
  )
}

export default InvoicePaidMenuItem